var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('strong',[_vm._v(_vm._s(_vm.item)+":")]),_c('span',{staticClass:"set-input-number"},[_c('a-input-number',{attrs:{"default-value":_vm.datas.firstconfig.b[_vm.item] * 1,"min":0,"max":480},on:{"change":_vm.setNum}}),_c('em',[_vm._v(_vm._s(_vm.$t('message["304"]')))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }